import React from 'react';
import CustomButton from './CustomButton';

import './theme.css';

export default class PluginDev extends React.Component {
  constructor(props)
  {
    super(props);
  }

  render()
  {
    return (
      <div className='ablak'>
        <h3>Plugin development</h3>
        <div className='keret szovegdoboz' style={{maxWidth: '450px', position: 'relative', left:'50%', transform: 'translate(-50%)'}}>
            If you're a plugin developer, me and <a target="_blank" rel="noopener" href='https://www.deviantart.com/dark-beam'>DarkBeam</a> have prepared a sample Visual Studio project. More info included.
            <div style={{textAlign: 'center', margin: '3%'}}>
              <CustomButton icon="file_download" newTab url="https://app.box.com/s/15hwygrfq8rwuqjnnclgl7yar9p2vxrc" tooltip="Download"/>
            </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Component/PluginDev.js